import React, { useMemo } from 'react'
import { Menu, Label, SpinnerField, NumberField, SliderField, Tooltip, Button, Spacer, Container, CheckBoxField } from '@sencha/ext-modern'

// minValue={1} maxValue={totalPageNum} pageNum={pageNum} onPageSelected={this.handlePageSelected}  onChgNumPerPage={this.handleChgNumPerPage}
export default ({ minPage, maxPage, pageNum, onPageSelected, onChgNumPerPage, pathname, tabName }) => {
	const handlePageChange = (f, v) => (Array.isArray(v) && (v = v[0]), onPageSelected(v))
	const rangeInfo = { minValue: minPage, maxValue: maxPage, value: pageNum, onChange: handlePageChange }
	const touchDevice = Ext.platformTags.touch
	const [SubComp, subCompProps, InputComp] = useMemo(() => (touchDevice
		? [Menu, {}, NumberField]
		: [Tooltip, { padding: '15', dismissDelay: 0, showDelay: 0, allowOver: true, align: 't-b' }, SpinnerField]
	), [touchDevice])

	const psnEnabled = !!Tyan.psnCfg?.managerInfos?.[pathname]?.[tabName]?.__enabled

	return <SubComp layout='vbox' width='180px' /* onShow={handleShow}  */{...subCompProps}>
		<Container layout='vbox' /* hidden={maxValue <= minValue} */>
			<Container layout='hbox' padding="5" style={{ fontSize: '12px', lineHeight: '18px' }}>
				<Label noLocale html={Tyan.t('页面跳转前缀', 'pub')} margin='5 5 0 0' />
				<InputComp errorTip={{ noLocale: true }} minWidth={10} label={null}  {...rangeInfo} disabled={minPage >= maxPage} textAlign='center' flex={1} clearable={false} />
				<Label noLocale html={Tyan.t('页面跳转后缀', 'pub')} margin='5 0 0 5' />
			</Container>
			<SliderField label={null} {...rangeInfo} liveUpdate padding="0 5 0 5" /* width='150px'  */ disabled={minPage >= maxPage} />
			<Container layout='hbox' padding='0 5 5 5' >
				<Spacer flex={1} />
				<Button text='' iconCls="x-fa fa-angle-double-left" ui='round' style={{ padding: '0px' }} tooltip='首页'
					handler={() => onPageSelected(minPage)} disabled={pageNum <= minPage} />
				<Spacer flex={1} />
				<Button text='' iconCls="x-fa fa-angle-left" ui='round' style={{ padding: '0px' }} tooltip='上一页'
					handler={() => onPageSelected(pageNum - 1)} disabled={pageNum <= minPage} />
				<Spacer flex={1} />
				<Button text='' iconCls="x-fa fa-angle-right" ui='round' style={{ padding: '0px' }} tooltip='下一页'
					handler={() => onPageSelected(pageNum + 1)} disabled={pageNum >= maxPage} />
				<Spacer flex={1} />
				<Button text='' iconCls="x-fa fa-angle-double-right" ui='round' style={{ padding: '0px' }} tooltip='末页'
					handler={() => onPageSelected(maxPage)} disabled={pageNum >= maxPage} />
				<Spacer flex={1} />
			</Container>
		</Container>
		<Container layout='hbox' padding='20 5 5 5' border='1 0 0 0'>
			<Label noLocale html={Tyan.t('每页记录数前缀', 'pub')} margin='5 5 0 0' />
			<InputComp errorTip={{ noLocale: true }} label={null} minValue={8} maxValue={1000} stepValue={10} minWidth={10} value={Tyan.psnCfg.numPerPage} textAlign='center'
				onChange={(f, v) => onChgNumPerPage(v)} flex={1} clearable={false}
			/>
			<Label noLocale html={Tyan.t('每页记录数后缀', 'pub')} margin='5 0 0 5' />
		</Container>
		<CheckBoxField boxLabel={Tyan.t('保留列设置', 'pub')} boxLabelAlign='before' bodyAlign='start'
			checked={psnEnabled} margin='10 5 5 5'
			onChange={(f, bSelected) => {
				Tyan.setPsnCfg({ managerInfos: { [pathname]: { [tabName]: { __enabled: bSelected } } } })
			}}
		/>
	</SubComp>
}
